export default __webpack_public_path__ + "static/above_fold_img-af3b2126d650c603c435b9115abf7d89.svg";